export default {
  meta: {
    title: '欢迎页',
  },
};
